module.exports = __webpack_public_path__ + "img/slide07.5c4e89c3.jpg";